import React, { useEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { api } from "../lib/api";

const Panel = ({ item, index }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [60, -60]);
  const even = index % 2 === 0;

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7 }}
      className={`grid md:grid-cols-2 gap-0 items-stretch ${even ? "" : "md:[direction:rtl]"}`}
      data-testid={`lore-panel-${item.chapter}`}
    >
      <div className="relative overflow-hidden min-h-[320px] md:min-h-[460px] clip-panel">
        <motion.img
          style={{ y }}
          src={item.image}
          alt={item.title}
          loading="lazy"
          className="absolute inset-0 w-full h-[120%] object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute top-4 left-4 font-display text-7xl md:text-8xl text-emerald-400/70 text-glow-green">{item.chapter}</div>
      </div>
      <div className="relative bg-gradient-to-br from-[#0C1310] to-black flex flex-col justify-center p-8 md:p-14 [direction:ltr]">
        <div className="halftone absolute inset-0 opacity-20" />
        <div className="relative">
          <p className="font-accent text-lg tracking-[0.3em] text-amber-500">CHAPTER {item.chapter}</p>
          <h3 className="font-display text-4xl md:text-5xl text-white mt-1">{item.title}</h3>
          <p className="text-gray-300 mt-4 leading-relaxed text-lg">{item.text}</p>
        </div>
      </div>
    </motion.div>
  );
};

export const LoreSection = () => {
  const [lore, setLore] = useState([]);
  useEffect(() => {
    api.get("/lore").then(({ data }) => setLore(data)).catch(() => {});
  }, []);

  return (
    <section id="lore" className="relative py-24 sm:py-32 bg-[#050806]" data-testid="lore-section">
      <div className="max-w-[1500px] mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="font-accent text-xl tracking-[0.3em] text-emerald-400">THE ORIGIN</p>
          <h2 className="font-display text-5xl sm:text-7xl text-white mt-1">STORIES & LORE</h2>
          <p className="text-gray-400 max-w-xl mx-auto mt-4">From blackout to legend — the world-building of NAIJAMAN, told in panels.</p>
        </motion.div>

        <div className="space-y-6">
          {lore.map((item, i) => (
            <Panel key={item.chapter} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
